import React from 'react'
import Svg from './Svg'
export const SvgFacilities = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M0 23.853h11.927V0H0v23.853zM7.454 2.981h2.981v2.983H7.454V2.981zm0 5.964h2.981v2.982H7.454V8.945zm0 5.963h2.981v2.983H7.454v-2.983zM1.491 2.981h2.982v2.983H1.491V2.981zm0 5.964h2.982v2.982H1.491V8.945zm0 5.963h2.982v2.983H1.491v-2.983zm11.927-7.454h10.435v1.491H13.418zm0 16.399h2.981v-5.962h4.473v5.962h2.981V10.435H13.418z" />
  </Svg>
))
SvgFacilities.isIcon = true
export default SvgFacilities
